
import React  , { useState }  from 'react';
import {
  TabsComponent,
} from '../../../../Components';
import { AgreementsAndComplianceVerticalTabsData} from './AgreementsAndCompliance' ; 

  export const AgreementsAndComplianceView = ({ parentTranslationPath , translationPath  , contactReletedWithDeveloperId }) => { 
    
    const [activeTab, setActiveTab] = useState(0);
    const onTabChanged = (e, newTap) => {
      setActiveTab(newTap);
    };
    

    return (
      <div className='mt-3 developer-profile-wrapper view-wrapper'>
        <TabsComponent
          data ={AgreementsAndComplianceVerticalTabsData}
          labelInput='label'
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          themeClasses='theme-curved'
          currentTab={activeTab}
          onTabChanged={onTabChanged}
          dynamicComponentProps={{
            parentTranslationPath,
            translationPath,
            setActiveTab : setActiveTab, 
            activeTab,
            contactReletedWithDeveloperId  
          }}
        />
      </div>
    );
  } ; 
  